import BaseInput from './base-input'

export default BaseInput